function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Plumber icon white");

var _ref3 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st1{fill:#FFFFFF;}\n\t.st2{mask:url(#c_1_);fill:#0059A9;}\n\t.st3{fill:#FEFEFE;}\n");

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  transform: "translate(27 26.45)"
}, React.createElement("defs", null, React.createElement("filter", {
  id: "Adobe_OpacityMaskFilter",
  filterUnits: "userSpaceOnUse",
  x: -27,
  y: -26.5,
  width: 100,
  height: 100
}, React.createElement("feColorMatrix", {
  type: "matrix",
  values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
}))), React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: -27,
  y: -26.5,
  width: 100,
  height: 100,
  id: "c_1_"
}, React.createElement("g", {
  className: "st0"
}, React.createElement("path", {
  id: "b_1_",
  className: "st1",
  d: "M-27-26.4H73v100H-27V-26.4z"
}))), React.createElement("path", {
  className: "st2",
  d: "M73,23.6c0-27.6-22.4-50-50-50c-27.6,0-50,22.4-50,50c0,27.6,22.4,50,50,50C50.6,73.5,73,51.2,73,23.6"
})), React.createElement("path", {
  className: "st3",
  d: "M17.8,17.8C9.6,26.1,4.5,37.4,4.5,50c0,12.6,5.1,23.9,13.3,32.2c8.2,8.2,19.6,13.3,32.2,13.3 c12.6,0,23.9-5.1,32.2-13.3c8.2-8.2,13.3-19.6,13.3-32.2c0-12.6-5.1-23.9-13.3-32.2C73.9,9.6,62.6,4.5,50,4.5 C37.4,4.5,26.1,9.6,17.8,17.8 M1.9,50C1.9,23.4,23.4,1.9,50,1.9c26.6,0,48.1,21.6,48.1,48.1c0,26.6-21.6,48.1-48.1,48.1 C23.4,98.1,1.9,76.6,1.9,50"
}), React.createElement("path", {
  className: "st3",
  d: "M50,78.2c-15.6,0-28.2-12.6-28.2-28.2c0-15.6,12.6-28.2,28.2-28.2S78.2,34.4,78.2,50 C78.2,65.6,65.6,78.2,50,78.2 M50,10c-22.1,0-40,17.9-40,40c0,22.1,17.9,40,40,40c22.1,0,40-17.9,40-40C90,27.9,72.1,10,50,10"
}));

var SvgIconPlumberWhite = function SvgIconPlumberWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconPlumberWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-plumber-white.06eb20b6.svg";
export { ForwardRef as ReactComponent };